import { FC, useContext, useEffect } from 'react';
import { CenterAlignedLoader } from '@medly-components/core';
import Error from 'pages/Error';
import { UserContext } from 'context/UserContext';
import { useNavigate } from 'react-router-dom';
import { MY_MAP_ROUTE } from 'constants/routes';
import { MapOnboardingContext } from 'context/MapOnboardingContext';
import { PAGE } from 'context/MapOnboardingContext/types';
import { MAP_ASSIGNMENT_STATUS } from 'pages/Home/components/features/Maps/utils';
import { useMapStatus } from 'hooks/user/useMapStatus';

/**
 * MapOnboardingProtectedRoute responsible for protected route against user map onboarding journey.
 */
export const MapOnboardingProtectedRoute: FC = ({ children }) => {
    const { user } = useContext(UserContext);
    const { setCurrentStep } = useContext(MapOnboardingContext);
    const navigate = useNavigate();
    const { status, isLoading, error } = useMapStatus();

    useEffect(() => {
        if (user?.assignedRegions?.length) {
            navigate(MY_MAP_ROUTE);
            return;
        }
        if (status === MAP_ASSIGNMENT_STATUS.IN_PROGRESS) {
            setCurrentStep(PAGE.MAP_ASSIGNMENT_INPROGRESS);
        }
        if (status === MAP_ASSIGNMENT_STATUS.CONTACTED) {
            setCurrentStep(PAGE.CONTACTED);
        }
    }, [user?.assignedRegions, status]);

    if (isLoading) {
        return (
            <main style={{ height: '100%' }}>
                <CenterAlignedLoader />
            </main>
        );
    }

    if (error) {
        return <Error />;
    }

    return <>{children}</>;
};
